import 'moment';
import template from './date-filter.component.html';
import { AttributeFilterController } from '../attribute-filter.component';

class DateFilterController extends AttributeFilterController {
	constructor() {
		'ngInject';
		super();

		this.showPresets = false;
		this.showDates = true;
	}

	$onInit() {
		this.showTimes = this.attr.rawAttr.dataType === 'Datetime';
		this.attr.selectedRange ? this.setSelectedRange() : (this.start = this.end = null);
		this.attr.rawAttr.range ? this.setRange() : (this.min = this.max = null);
	}

	$postLink() {
		this.setHelp();
	}

	setSelectedRange() {
		const { selectedRange } = this.attr;
		this.start = selectedRange.min ? moment(selectedRange.min).toDate() : null;
		this.end = selectedRange.max ? moment(selectedRange.max).toDate() : null;
	}

	setRange() {
		const { range } = this.attr.rawAttr;
		this.min = range.min ? moment(range.min).toDate() : null;
		this.max = range.max ? moment(range.max).toDate() : null;
	}

	setHelp() {
		this.getHelp({ help: 'dateRange' });
	}

	updateStartDate(start) {
		if (start) {
			this.attr.selectedRange.min =
				this.attr.rawAttr.dataType !== 'Datetime'
					? moment(start)
							.toISOString()
							.slice(0, 10)
					: moment(start).toISOString();
		} else {
			delete this.attr.selectedRange.min;
		}
		this.checkDateValidation();
	}

	updateEndDate(end) {
		if (end) {
			this.attr.selectedRange.max =
				this.attr.rawAttr.dataType !== 'Datetime'
					? moment(end)
							.startOf('day')
							.toISOString()
							.slice(0, 10)
					: moment(end).toISOString();
		} else {
			delete this.attr.selectedRange.max;
		}
		this.checkDateValidation();
	}

	checkDateValidation() {
		if (this.dateFilterForm) {
			this.dateFilterForm.$setValidity('required', Object.keys(this.attr.selectedRange).length !== 0);
		}
	}
}

export const dateFilterComponent = {
	template,
	controller: DateFilterController,
	controllerAs: 'vm',
	bindings: {
		attr: '<',
		getHelp: '&'
	}
};
